import { CircularProgress } from '@mui/material';
import { IconButton } from '../../../button/IconButton/IconButton';
import styles from './FileUploadInProgressButton.module.scss';

export function FileUploadInProgressButton({ dataId }: { dataId: string }) {
  return (
    <IconButton
      type='button'
      aria-label='progress'
      dataId={dataId}
      label=''
      onClick={e => e.stopPropagation()}
    >
      <CircularProgress size={10} className={styles.progress} />
    </IconButton>
  );
}
